export class CurrencyPairPriceDto {
  [key: string]: number;
}
